import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApiModule } from '@sb/library/api';
import { BaseModule } from '@sb/library/base';

@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        BaseModule,
        ApiModule,
    ],
    exports: [
    ]
})
export class ElevioModule { }
